import { render, staticRenderFns } from "./ClickAndBuyMediaForm.vue?vue&type=template&id=4c60f75b&scoped=true"
import script from "./ClickAndBuyMediaForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyMediaForm.vue?vue&type=script&lang=js"
import style0 from "./ClickAndBuyMediaForm.vue?vue&type=style&index=0&id=4c60f75b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60f75b",
  null
  
)

export default component.exports